import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47492350"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "PROTECCIÓN DE DATOS PERSONALES", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " En cumplimiento de lo dispuesto en la LEY ESTATUTARIA 1581 de 2012 y el decreto reglamentario parcial No 1377 de 2013, el titular de la información declara y acepta que sus datos personales quedarán incorporados y serán tratados en las bases de datos de VIACARGO S.A.S, sucursales, con finalidades de: recolección, registro, y actualización de la información para efectos de comunicación, acreditación, capacitación y cualquier otra finalidad acorde al objeto de la empresa y de acuerdo con la política de tratamiento de datos que podrá ser conocida a través de www.viacargo.com.co Le informamos la posibilidad de ejercer los derechos de acceso, rectificación, cancelación y oposición de sus datos de carácter personal, solicitándolo en la forma establecida en la política. ", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("OK")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.open_terms,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.open_terms) = $event)),
    width: "50%"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", null, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open_terms = false))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }, 8, ["modelValue"]))
}